<script setup lang="ts">
import { ref } from "vue";
import { locale } from "../../../locale";
import ToolTip from "../../ToolTip.vue";
import { loadingRecordState, recordState, ChangeRecord } from "../../../states/recordState";
const btn = ref<HTMLElement | null>(null);
</script>
<template>
  <button ref="btn" class="recording-button" @click="ChangeRecord" :class="{
    active: recordState.recording,
  }">
    <template v-if="loadingRecordState">
      <span class="loader"></span>
    </template>
    <template v-else>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12.0004" cy="11.9999" r="8.85" stroke="currentColor" stroke-width="1.5" />
        <circle cx="12.0002" cy="12" r="4.8" fill="currentColor" />
      </svg>
    </template>
    <ToolTip :placement="'top'" :reference="btn">{{ recordState.recording ? locale.endrecord : locale.startrecord }}
    </ToolTip>
  </button>
</template>
<style scoped>
.recording-button {
  width: 44px;
  height: 44px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
  border-radius: 50px;
  border: none;
  cursor: pointer;
  background-color: var(--record-btn-off-bg-regular);
  color: var(--record-btn-off-content-regular);
}

.recording-button.active {
  background-color: var(--record-btn-on-bg-regular);
  color: var(--record-btn-on-content-regular);
}

.recording-button:hover {
  background-color: var(--record-btn-off-bg-hover);
  color: var(--record-btn-off-content-hover);
}

.recording-button:active {
  background-color: var(--record-btn-off-bg-active);
  color: var(--record-btn-off-content-active);
}

.recording-button.active:hover {
  background-color: var(--record-btn-on-bg-hover);
  color: var(--record-btn-on-content-hover);
}

.recording-button.active:active {
  background-color: var(--record-btn-on-bg-active);
  color: var(--record-btn-on-content-active);
}

.recording-button:focus {
  outline: none;
}

.loader {
  width: 24px;
  height: 24px;
  border: 3px solid #fff;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
